import { ReactNode } from 'react';

import { useDroppable } from '@dnd-kit/core';

export type DroppableSlotProps = {
  id: string;
  isDragOver: boolean;
  children: ReactNode;
};

export const DroppableSlot = ({
  id,
  isDragOver,
  children,
}: DroppableSlotProps) => {
  const { setNodeRef } = useDroppable({
    id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`rounded-lg border transition-colors ${
        isDragOver
          ? 'border-2 border-dashed border-blue-500 bg-blue-100'
          : 'border-gray-200 bg-gray-50'
      }`}
    >
      {children}
    </div>
  );
};
